import FILTER_TYPES from '@/components/query/filter-types';
import API_SPEC_FIELD_TYPES from '@/components/query/helpers/api-spec-field-types';

/**
 * Resolve the field type from the API spec into a type
 * that can be used in the UI.
 * @param field
 * @returns {string}
 */
export default function resolveFilterType(field) {
    switch (field.type) {
        case API_SPEC_FIELD_TYPES.boolean:
            return FILTER_TYPES.boolean;
        case API_SPEC_FIELD_TYPES.date:
        case API_SPEC_FIELD_TYPES.datetime:
            return FILTER_TYPES.datetime;
        case API_SPEC_FIELD_TYPES.integer:
        case API_SPEC_FIELD_TYPES.number:
            return FILTER_TYPES.numeric;
        case API_SPEC_FIELD_TYPES.monetary:
            // this field isn't supported by criteria
            return API_SPEC_FIELD_TYPES.monetary;
        case FILTER_TYPES.random:
            return FILTER_TYPES.random;
        case API_SPEC_FIELD_TYPES.array:
        case API_SPEC_FIELD_TYPES.string:
        default:
            // special case for string as dates
            if (field.format === 'date-time') {
                return FILTER_TYPES.datetime;
            }
            if (field.enum !== undefined
                || (field.additionalSchema && field.additionalSchema.allowedValues)) {
                // enum type or custom field with restrictions
                return FILTER_TYPES.enum;
            }
            return FILTER_TYPES.text;
    }
}
